import {PREFIX_COIN, PREFIX_FIAT_COIN} from '@/const';

export const coinUtil = {
  getUrl(coin) {
    coin = ['MUSDT', 'PUSD'].includes(coin) ? 'USDT' : coin;
    return PREFIX_COIN + coin + '.svg';
  },
};

export const fiatUtil = {
  getUrl(fiat) {
    return PREFIX_FIAT_COIN + fiat + '.svg';
  },
};
